export default [
  {
    path: '/prog_agr/fertilizacion/programacion',
    name: 'prfertprogramacion',
    component: () => import('@/views/programaciones_agricolas/programacion_fertilizacion'),
    meta: {
      pageTitle: 'Programación Fertilización',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
          active: true,
        },
        {
          text: 'Fertilización',
          active: true,
        },
        {
          text: 'Programación',
          active: true,
        },
      ],
      resource: 'Pr Fert Programacion',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/fertilizacion/reportes',
    name: 'prfertreporte',
    component: () => import('@/views/programaciones_agricolas/programacion_fert_reporte.vue'),
    meta: {
      pageTitle: 'Reportes de Fertilización',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
          active: true,
        },
        {
          text: 'Fertilización',
          active: true,
        },
        {
          text: 'Reportes',
          active: true,
        },
      ],
      resource: 'Pr Ma Fe Area',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/fertilizacion/tablero',
    name: 'prferttablero',
    component: () => import('@/views/programaciones_agricolas/tablero_fertilizacion'),
    meta: {
      pageTitle: 'Tablero de Cruce',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
          active: true,
        },
        {
          text: 'Fertilización',
          active: true,
        },
        {
          text: 'Tablero de Cruce',
          active: true,
        },
      ],
      resource: 'Pr Fert Tablero',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/riego/programacion',
    name: 'prriegprogramacion',
    component: () => import('@/views/programaciones_agricolas/programacion_riego'),
    meta: {
      pageTitle: 'Programación Riego',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
          active: true,
        },
        {
          text: 'Riego',
          active: true,
        },
        {
          text: 'Programación',
          active: true,
        },
      ],
      resource: 'Pr Rieg Programacion',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/riego/reporte_general',
    name: 'reportesgeneral',
    component: () => import('@/views/programaciones_agricolas/programacion_riego_reporte_general'),
    meta: {
      pageTitle: 'Resumen General',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
          active: true,
        },
        {
          text: 'Riego',
          active: true,
        },
        {
          text: 'Resumen General',
          active: true,
        },
      ],
      resource: 'Reportes Riego',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/riego/reporte_porvariedad',
    name: 'reportesporvariedad',
    component: () => import('@/views/programaciones_agricolas/programacion_riego_reporte_variedad'),
    meta: {
      pageTitle: 'Reporte Por Variedad',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
          active: true,
        },
        {
          text: 'Riego',
          active: true,
        },
        {
          text: 'Reporte Por Variedad',
          active: true,
        },
      ],
      resource: 'Reportes Riego',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/riego/reporte_detallado',
    name: 'reportesdetallado',
    component: () => import('@/views/programaciones_agricolas/programacion_riego_reporte_detallado'),
    meta: {
      pageTitle: 'Reporte Detallado',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
          active: true,
        },
        {
          text: 'Riego',
          active: true,
        },
        {
          text: 'Reporte Detallado',
          active: true,
        },
      ],
      resource: 'Reportes Riego',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/maquinaria/programacion',
    name: 'prmaquprogramacion',
    component: () => import('@/views/programaciones_agricolas/programacion_maquinaria'),
    meta: {
      pageTitle: 'Programación',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
          active: true,
        },
        {
          text: 'Maquinaria',
          active: true,
        },
        {
          text: 'Programación',
          active: true,
        },
      ],
      resource: 'Pr Maqu Programacion',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/maquinaria/tablero',
    name: 'prmaqutablero',
    component: () => import('@/views/programaciones_agricolas/tablero_maquinaria'),
    meta: {
      pageTitle: 'Tablero de Cruce',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
          active: true,
        },
        {
          text: 'Maquinaria',
          active: true,
        },
        {
          text: 'Tablero de Cruce',
          active: true,
        },
      ],
      resource: 'Pr Maqu Tablero',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/m_obra/programacion',
    name: 'prmobrprogramacion',
    component: () => import('@/views/programaciones_agricolas/programacion_m_obra'),
    meta: {
      pageTitle: 'Programación',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
          active: true,
        },
        {
          text: 'Mano de Obra',
          active: true,
        },
        {
          text: 'Programación',
          active: true,
        },
      ],
      resource: 'Pr MObr Programacion',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/m_obra/tablero',
    name: 'prmobrtablero',
    component: () => import('@/views/programaciones_agricolas/tablero_m_obra'),
    meta: {
      pageTitle: 'Tablero de Cruce',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
          active: true,
        },
        {
          text: 'Mano de Obra',
          active: true,
        },
        {
          text: 'Tablero de Cruce',
          active: true,
        },
      ],
      resource: 'Pr MObr Tablero',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/fertilizacion/areas',
    name: 'prmanareas',
    component: () => import('@/views/programaciones_agricolas/mant_fertilizacion/man_areas'),
    meta: {
      pageTitle: 'Áreas',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Áreas',
          active: true,
        },
      ],
      resource: 'Pr Man Areas',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/fertilizacion/sub_areas',
    name: 'prmansubareas',
    component: () => import('@/views/programaciones_agricolas/mant_fertilizacion/man_sub_areas'),
    meta: {
      pageTitle: 'Sub-Áreas',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Sub-Áreas',
          active: true,
        },
      ],
      resource: 'Pr Man SubAreas',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/fertilizacion/responsables',
    name: 'prmanresponsables',
    component: () => import('@/views/programaciones_agricolas/mant_fertilizacion/man_responsables'),
    meta: {
      pageTitle: 'Usuarios',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Usuarios',
          active: true,
        },
      ],
      resource: 'Pr Man Responsables',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/fertilizacion/implementos',
    name: 'prmanimplementos',
    component: () => import('@/views/programaciones_agricolas/mant_fertilizacion/man_implementos'),
    meta: {
      pageTitle: 'Implementos',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Implementos',
          active: true,
        },
      ],
      resource: 'Pr Man Implementos',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/fertilizacion/lotes_valvulas',
    name: 'prmanlotes',
    component: () => import('@/views/programaciones_agricolas/mant_fertilizacion/man_lotes_new'),
    meta: {
      pageTitle: 'Lotes y Válvulas',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Lotes y Válvulas',
          active: true,
        },
      ],
      resource: 'Pr Man Lotes',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/fertilizacion/tipos_programas',
    name: 'prmantprogramas',
    component: () => import('@/views/programaciones_agricolas/mant_fertilizacion/man_tipos_programas'),
    meta: {
      pageTitle: 'Tipos de Programas',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Tipos de Programas',
          active: true,
        },
      ],
      resource: 'Pr Man TProgramas',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/fertilizacion/parametros',
    name: 'prmanparametros',
    component: () => import('@/views/programaciones_agricolas/mant_fertilizacion/man_parametros'),
    meta: {
      pageTitle: 'Parámetros',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Parámetros',
          active: true,
        },
      ],
      resource: 'Pr Man Parametros',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/fertilizacion/productos',
    name: 'prproductos',
    component: () => import('@/views/programaciones_agricolas/mant_fertilizacion/man_productos'),
    meta: {
      pageTitle: 'Productos',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Productos',
          active: true,
        },
      ],
      resource: 'Pr Man Parametros',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/maquinaria/maquinarias',
    name: 'prmaquinarias',
    component: () => import('@/views/programaciones_agricolas/mant_maquinaria/man_maquinarias'),
    meta: {
      pageTitle: 'Maquinarias',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Maquinarias',
          active: true,
        },
      ],
      resource: 'Pr Ma Fe Area',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/maquinaria/implementos',
    name: 'primplementos',
    component: () => import('@/views/programaciones_agricolas/mant_maquinaria/man_implementos'),
    meta: {
      pageTitle: 'Implementos',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Implementos',
          active: true,
        },
      ],
      resource: 'Pr Ma Fe Area',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/maquinaria/actividad&labor',
    name: 'practlab',
    component: () => import('@/views/programaciones_agricolas/mant_maquinaria/man_act_lab'),
    meta: {
      pageTitle: 'Actividad & Labor',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Actividad & Labor',
          active: true,
        },
      ],
      resource: 'Pr Ma Fe Area',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/maquinaria/turnos',
    name: 'prturceco',
    component: () => import('@/views/programaciones_agricolas/mant_maquinaria/man_turno_ceco'),
    meta: {
      pageTitle: 'Turnos',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Turnos',
          active: true,
        },
      ],
      resource: 'Pr Ma Fe Area',
      action: 'menu',
    },
  },
  {
    path: '/prog_agr/mantenedores/maquinaria/Usuarios',
    name: 'prresponsables',
    component: () => import('@/views/programaciones_agricolas/mant_maquinaria/man_responsables'),
    meta: {
      pageTitle: 'Usuarios',
      breadcrumb: [
        {
          text: 'Programaciones Agrícolas',
        },
        {
          text: 'Mantenedores',
        },
        {
          text: 'Usuarios',
          active: true,
        },
      ],
      resource: 'Pr Ma Fe Area',
      action: 'menu',
    },
  },
]
